module.exports = __webpack_public_path__ + "img/bgmain.cfe7451.cfe74512.png";